import { http } from "../api";
const easyUnpack = ({ data }) => data;
export const LassieActionApi = {
    create_action_condition: {
        f: function create_action_condition(scenario_id, action_type) {
            let url = '/lassie/action/$scenario_id/action-condition';
            let parameterNames = ["$scenario_id"];
            [scenario_id].forEach((parameterValue, index) => {
                url = url.replace(parameterNames[index], parameterValue)
            })
            return http.post(url, { action_type }).then(easyUnpack)
        }
    },
    update_action_condition: {
        f: function update_action_condition(condition_id, action_type) {
            let url = '/lassie/action/$condition_id';
            let parameterNames = ["$condition_id"];
            [condition_id].forEach((parameterValue, index) => {
                url = url.replace(parameterNames[index], parameterValue)
            })
            return http.put(url, { action_type }).then(easyUnpack)
        }
    },
    deactivate_action_condition: {
        f: function deactivate_lassie_action_condition(condition_id) {
            let url = '/lassie/action/$condition_id/deactivate';
            let parameterNames = ["$condition_id"];
            [condition_id].forEach((parameterValue, index) => {
                url = url.replace(parameterNames[index], parameterValue)
            })
            return http.patch(url, {}).then(easyUnpack)
        }
    },
};
